import { get, startCase } from 'lodash';

export class Dataset {
  constructor(public name: string, readonly type: string = null, readonly meta: any = null) {}

  get displayName(): string {
    return get(this.meta, 'display.name') || startCase(this.name.replace(/_/g, ' '));
  }
}
